"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
var GA4 = /** @class */ (function (_super) {
    __extends(GA4, _super);
    function GA4(name, config) {
        var _this = _super.call(this, name) || this;
        _this.config = [];
        _this.flowStage = -1;
        _this.config = config.measurementIds;
        // @ts-ignore
        if (window.gtag === undefined) {
            window.dataLayer = window.dataLayer || [];
            // @ts-ignore
            function gtag() {
                window.dataLayer.push(arguments);
            }
            // @ts-ignore
            window.gtag = gtag;
            // @ts-ignore
            window.gtag("js", new Date());
        }
        return _this;
    }
    GA4.prototype.incrementFlowStage = function () {
        this.flowStage += 1;
    };
    GA4.prototype.resetFlowStage = function () {
        this.flowStage = -1;
    };
    GA4.prototype.lowerCase = function (value) {
        return (value !== null && value !== void 0 ? value : "").toLowerCase();
    };
    GA4.prototype.sendRetailProcessViewedEvent = function (flowName, vehicle) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        this.incrementFlowStage();
        // @ts-ignore
        window.gtag("event", "asc_retail_process", {
            event_owner: "online_shopper",
            // @ts-ignore
            page_type: this.lowerCase((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.asc_dataLayer) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.page_type) !== null && _c !== void 0 ? _c : "unknown"),
            flow_name: flowName,
            element_title: "",
            flow_outcome: "viewed",
            item_payment: this.lowerCase((_e = (_d = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _d === void 0 ? void 0 : _d.selected) !== null && _e !== void 0 ? _e : "cash"),
            flow_stage: this.flowStage,
            item_id: vehicle.vin,
            item_number: vehicle.stock,
            item_price: (_l = (_k = (_j = (_f = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _f === void 0 ? void 0 : _f[(_h = (_g = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _g === void 0 ? void 0 : _g.selected) !== null && _h !== void 0 ? _h : "cash"]) === null || _j === void 0 ? void 0 : _j.price) !== null && _k !== void 0 ? _k : vehicle.msrp) !== null && _l !== void 0 ? _l : "",
            item_condition: this.lowerCase(vehicle.type),
            item_year: vehicle.year,
            item_make: this.lowerCase(vehicle.make),
            item_model: this.lowerCase(vehicle.model),
            item_variant: this.lowerCase(vehicle.trim),
            item_color: "",
            item_type: this.lowerCase(vehicle.bodytype),
            item_category: "",
            item_fuel_type: "",
            item_inventory_date: "",
            send_to: this.config,
        });
    };
    GA4.prototype.sendFormSubmissionSalesAptEvent = function (formType, dealUuid, vehicle) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        // @ts-ignore
        window.gtag("event", "asc_form_submission", {
            event_owner: "online_shopper",
            // @ts-ignore
            page_type: this.lowerCase((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.asc_dataLayer) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.page_type) !== null && _c !== void 0 ? _c : "unknown"),
            comm_type: "form",
            comm_outcome: "",
            submission_id: dealUuid,
            form_name: "online_shopper",
            form_type: formType,
            department: "sales",
            item_payment: this.lowerCase((_e = (_d = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _d === void 0 ? void 0 : _d.selected) !== null && _e !== void 0 ? _e : "cash"),
            item_id: vehicle.vin,
            item_number: vehicle.stock,
            item_price: (_l = (_k = (_j = (_f = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _f === void 0 ? void 0 : _f[(_h = (_g = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _g === void 0 ? void 0 : _g.selected) !== null && _h !== void 0 ? _h : "cash"]) === null || _j === void 0 ? void 0 : _j.price) !== null && _k !== void 0 ? _k : vehicle.msrp) !== null && _l !== void 0 ? _l : "",
            item_condition: this.lowerCase(vehicle.type),
            item_year: vehicle.year,
            item_make: this.lowerCase(vehicle.make),
            item_model: this.lowerCase(vehicle.model),
            item_variant: this.lowerCase(vehicle.trim),
            item_color: "",
            item_type: this.lowerCase(vehicle.bodytype),
            item_category: "",
            item_fuel_type: "",
            item_inventory_date: "",
            send_to: this.config,
        });
        // @ts-ignore
        window.gtag("event", "asc_form_submission_sales_appt", {
            event_owner: "online_shopper",
            // @ts-ignore
            page_type: this.lowerCase((_p = (_o = (_m = window === null || window === void 0 ? void 0 : window.asc_dataLayer) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.page_type) !== null && _p !== void 0 ? _p : "unknown"),
            comm_type: "form",
            comm_outcome: "",
            submission_id: dealUuid,
            form_name: "online_shopper",
            form_type: formType,
            department: "sales",
            item_payment: this.lowerCase((_r = (_q = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _q === void 0 ? void 0 : _q.selected) !== null && _r !== void 0 ? _r : "cash"),
            item_id: vehicle.vin,
            item_number: vehicle.stock,
            item_price: (_x = (_w = (_v = (_s = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _s === void 0 ? void 0 : _s[(_u = (_t = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _t === void 0 ? void 0 : _t.selected) !== null && _u !== void 0 ? _u : "cash"]) === null || _v === void 0 ? void 0 : _v.price) !== null && _w !== void 0 ? _w : vehicle.msrp) !== null && _x !== void 0 ? _x : "",
            item_condition: this.lowerCase(vehicle.type),
            item_year: vehicle.year,
            item_make: this.lowerCase(vehicle.make),
            item_model: this.lowerCase(vehicle.model),
            item_variant: this.lowerCase(vehicle.trim),
            item_color: "",
            item_type: this.lowerCase(vehicle.bodytype),
            item_category: "",
            item_fuel_type: "",
            item_inventory_date: "",
            send_to: this.config,
        });
    };
    GA4.prototype.sendFormSubmissionSalesEvent = function (formType, dealUuid, vehicle) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        // @ts-ignore
        window.gtag("event", "asc_form_submission", {
            event_owner: "online_shopper",
            // @ts-ignore
            page_type: this.lowerCase((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.asc_dataLayer) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.page_type) !== null && _c !== void 0 ? _c : "unknown"),
            comm_type: "form",
            comm_outcome: "",
            submission_id: dealUuid,
            form_name: "online_shopper",
            form_type: formType,
            department: "sales",
            item_payment: this.lowerCase((_e = (_d = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _d === void 0 ? void 0 : _d.selected) !== null && _e !== void 0 ? _e : "cash"),
            item_id: vehicle.vin,
            item_number: vehicle.stock,
            item_price: (_l = (_k = (_j = (_f = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _f === void 0 ? void 0 : _f[(_h = (_g = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _g === void 0 ? void 0 : _g.selected) !== null && _h !== void 0 ? _h : "cash"]) === null || _j === void 0 ? void 0 : _j.price) !== null && _k !== void 0 ? _k : vehicle.msrp) !== null && _l !== void 0 ? _l : "",
            item_condition: this.lowerCase(vehicle.type),
            item_year: vehicle.year,
            item_make: this.lowerCase(vehicle.make),
            item_model: this.lowerCase(vehicle.model),
            item_variant: this.lowerCase(vehicle.trim),
            item_color: "",
            item_type: this.lowerCase(vehicle.bodytype),
            item_category: "",
            item_fuel_type: "",
            item_inventory_date: "",
            send_to: this.config,
        });
        // @ts-ignore
        window.gtag("event", "asc_form_submission_sales", {
            event_owner: "online_shopper",
            // @ts-ignore
            page_type: this.lowerCase((_p = (_o = (_m = window === null || window === void 0 ? void 0 : window.asc_dataLayer) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.page_type) !== null && _p !== void 0 ? _p : "unknown"),
            comm_type: "form",
            comm_outcome: "",
            submission_id: dealUuid,
            form_name: "online_shopper",
            form_type: formType,
            department: "sales",
            item_payment: (_r = (_q = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _q === void 0 ? void 0 : _q.selected) !== null && _r !== void 0 ? _r : "cash",
            item_id: vehicle.vin,
            item_number: vehicle.stock,
            item_price: (_x = (_w = (_v = (_s = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _s === void 0 ? void 0 : _s[(_u = (_t = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _t === void 0 ? void 0 : _t.selected) !== null && _u !== void 0 ? _u : "cash"]) === null || _v === void 0 ? void 0 : _v.price) !== null && _w !== void 0 ? _w : vehicle.msrp) !== null && _x !== void 0 ? _x : "",
            item_condition: this.lowerCase(vehicle.type),
            item_year: vehicle.year,
            item_make: this.lowerCase(vehicle.make),
            item_model: this.lowerCase(vehicle.model),
            item_variant: this.lowerCase(vehicle.trim),
            item_color: "",
            item_type: this.lowerCase(vehicle.bodytype),
            item_category: "",
            item_fuel_type: "",
            item_inventory_date: "",
            send_to: this.config,
        });
    };
    /**
     * General Events
     */
    GA4.prototype.closed = function (dealId, vehicle) {
        this.resetFlowStage();
    };
    /**
     * Garage Events
     */
    GA4.prototype.garageViewed = function (dealId, vehicle) {
        this.sendRetailProcessViewedEvent("compare", vehicle);
    };
    /**
     * Lead form events
     */
    GA4.prototype.leadFormViewed = function (dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("contact_info", vehicle);
    };
    GA4.prototype.leadFormFinished = function (dealUuid, vehicle) {
        this.sendFormSubmissionSalesEvent("contact_info", dealUuid, vehicle);
    };
    /**
     * Payment Calculator Events
     */
    GA4.prototype.paymentCalcViewed = function (dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("payment_calculator", vehicle);
    };
    GA4.prototype.paymentCalcFinished = function (dealUuid, vehicle) {
        this.sendFormSubmissionSalesEvent("payment_calculator", dealUuid, vehicle);
    };
    /**
     * Test Drive Events
     */
    GA4.prototype.testDriveFormViewed = function (dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("test_drive", vehicle);
    };
    GA4.prototype.testDriveFormFinished = function (dealUuid, vehicle) {
        this.sendFormSubmissionSalesAptEvent("test_drive", dealUuid, vehicle);
    };
    /**
     * Reserve Vehicle Events
     */
    GA4.prototype.reserveVehicleFormViewed = function (dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("reserve_vehicle", vehicle);
    };
    GA4.prototype.reserveVehicleFormFinished = function (dealUuid, vehicle) {
        this.sendFormSubmissionSalesEvent("reserve_vehicle", dealUuid, vehicle);
    };
    /**
     * Upgrade events
     */
    GA4.prototype.upgradesViewed = function (dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("accessories", vehicle);
    };
    GA4.prototype.upgradesFinished = function (dealUuid, vehicle) {
        this.sendFormSubmissionSalesEvent("accessories", dealUuid, vehicle);
    };
    GA4.prototype.menuingViewed = function (dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("service_plans", vehicle);
    };
    GA4.prototype.menuingFinished = function (dealUuid, vehicle) {
        this.sendFormSubmissionSalesEvent("service_plans", dealUuid, vehicle);
    };
    /**
     * Trade In Events
     */
    GA4.prototype.tradeInFormViewed = function (dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("trade", vehicle);
    };
    GA4.prototype.tradeInFormFinished = function (dealUuid, vehicle, programParticipation) {
        this.sendFormSubmissionSalesEvent("trade", dealUuid, vehicle);
    };
    /**
     * Soft Credit Pull
     */
    GA4.prototype.softCreditFormViewed = function (dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("soft_pull", vehicle);
    };
    GA4.prototype.softCreditFormFinished = function (dealUuid, vehicle, applicationId) {
        this.sendFormSubmissionSalesEvent("soft_pull", dealUuid, vehicle);
    };
    /**
     * Hard Credit Pull
     */
    GA4.prototype.hardCreditFormViewed = function (dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("credit_app", vehicle);
    };
    GA4.prototype.hardCreditFormFinished = function (dealUuid, vehicle, applicationId) {
        this.sendFormSubmissionSalesEvent("credit_app", dealUuid, vehicle);
    };
    /**
     * Schedule Pickup / Delivery form
     */
    GA4.prototype.schedulePickupOrDeliveryFormViewed = function (dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("delivery", vehicle);
    };
    GA4.prototype.schedulePickupOrDeliveryFormFinished = function (dealUuid, vehicle) {
        this.sendFormSubmissionSalesAptEvent("delivery", dealUuid, vehicle);
    };
    GA4.prototype.continueDeal = function (vin, dealUuid, vehicle) {
        this.sendRetailProcessViewedEvent("finalize_deal", vehicle);
    };
    return GA4;
}(index_1.AnalyticsProvider));
exports.default = GA4;
